import React, { useState, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useSecureAuth } from '../../contexts/SecureAuthContext';
import { useUser } from '../../contexts/UserContext';
import SupportFAB from './SupportFAB';
import SupportPanel from './SupportPanel';

const SupportWidget: React.FC = () => {
  const { isAuthenticated } = useSecureAuth();
  const { isMasterAccount, isApprovedResearcher } = useUser();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const fabRef = useRef<HTMLButtonElement>(null);

  const isParticipantRoute = /^\/(participant|fitbit)\//.test(location.pathname);
  const isLandingPage = location.pathname === '/';

  const shouldShow =
    isAuthenticated &&
    (isMasterAccount || isApprovedResearcher) &&
    !isParticipantRoute &&
    !isLandingPage;

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  if (!shouldShow) return null;

  return (
    <>
      <SupportFAB ref={fabRef} onClick={handleOpen} isOpen={isOpen} />
      <AnimatePresence>
        {isOpen && <SupportPanel onClose={handleClose} fabRef={fabRef} />}
      </AnimatePresence>
    </>
  );
};

export default SupportWidget;
